import React from 'react';
import ReactDOM from 'react-dom/client';
import './PersonalityTest.css';
import PersonalityTest from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PersonalityTest />
  </React.StrictMode>
);
